import { render, staticRenderFns } from "./HeaderNavs.vue?vue&type=template&id=10496a84&scoped=true"
import script from "./HeaderNavs.vue?vue&type=script&lang=js"
export * from "./HeaderNavs.vue?vue&type=script&lang=js"
import style0 from "./HeaderNavs.vue?vue&type=style&index=0&id=10496a84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10496a84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/b2bprionecokr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10496a84')) {
      api.createRecord('10496a84', component.options)
    } else {
      api.reload('10496a84', component.options)
    }
    module.hot.accept("./HeaderNavs.vue?vue&type=template&id=10496a84&scoped=true", function () {
      api.rerender('10496a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/header/HeaderNavs.vue"
export default component.exports